import { ShieldCheck } from "lucide-react";

export function Brand({ compact = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="fc-brand">
      <div
        className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl fc-mono text-lg font-semibold"
        style={{ backgroundColor: "var(--fc-navy)", color: "#fff" }}
      >
        FC
      </div>
      <div className="leading-tight">
        <div className="font-serif text-xl font-semibold text-foreground">Foncier Clair</div>
        {!compact && (
          <div className="fc-mono text-[11px] uppercase tracking-wider" style={{ color: "var(--fc-secondary-text)" }}>
            Prescription acquisitive · Outre-mer
          </div>
        )}
      </div>
    </div>
  );
}

export function Header() {
  return (
    <header className="no-print border-b border-border bg-card/70 backdrop-blur-sm">
      <div className="mx-auto flex max-w-4xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
        <Brand />
        <div className="fc-mono hidden text-[11px] uppercase tracking-wider sm:block" style={{ color: "var(--fc-secondary-text)" }}>
          Un outil AUPRÉA
        </div>
      </div>
    </header>
  );
}

export function Footer() {
  return (
    <footer className="no-print mt-16 border-t border-border py-8">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="fc-mono text-[11px] leading-relaxed" style={{ color: "var(--fc-secondary-text)" }}>
          AUPRÉA SAS · SIRET 933 283 459 00016 · Grand-Bourg, Guadeloupe · contact@auprea.com · www.auprea.com
        </div>
        <p className="mt-3 text-xs" style={{ color: "var(--fc-secondary-text)" }}>
          Outil d'information à visée pédagogique. Il ne constitue pas un conseil juridique individualisé et ne
          remplace pas la consultation d'un professionnel du droit.
        </p>
      </div>
    </footer>
  );
}

export function ConfidentialBadge() {
  return (
    <div
      className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-medium"
      style={{ backgroundColor: "var(--fc-surface2)", color: "var(--fc-secondary-text)" }}
    >
      <ShieldCheck size={14} style={{ color: "var(--fc-teal)" }} />
      Accès privé — dossier confidentiel
    </div>
  );
}
